import { useNavigate } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import CreateJobForm from "../../../../components/GeneralJobForm/CreateJobForm";
import ItemOthersService from "../../../../services/itemother.service";
import FileUploadsService from "../../../../services/fileupload.service";
import JobOtherPricesService from "../../../../services/jobotherprice.service";
import InformOtherJobsService from "../../../../services/informotherjob.service";
import InformOtherJobFilesService from "../../../../services/informotherjobfile.service";

export default function CreateJob() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  const commonNavigate = (Inform_Id) => {
    navigate("/general_job/create", {
      state: { name: "data", searchValue: `${Inform_Id}` }
    });
    navigate(0);
  };

  const handleSubmit = ({ Inform, Item, Job }, uploadFile) => {
    let Inform_Id = null;
    let ItemOther = null;
    let JobOther = null;
    let refreshAt = "";
    const files = [
      ...uploadFile.Image.filter((item) => item instanceof File),
      ...uploadFile.Video.filter((item) => item instanceof File)
    ];
    const commonMapping = (item) => ({ ...item, Job_Other_Id: Inform_Id });

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: InformOtherJobsService.createInformOtherJobs(Inform),
      callback: (response) => {
        Inform_Id = response.generatedMaps[0].Id;
        ItemOther = { Array: Item?.Array.map(commonMapping) };
        JobOther = { Array: Job?.Array.map(commonMapping) };
        refreshAt =
          files?.length > 0
            ? "InformFiles"
            : JobOther.Array
            ? "JobOther"
            : ItemOther.Array
            ? "ItemOther"
            : "Inform";

          console.log(JobOther.Array)

        if (ItemOther.Array)
          handleSubmitItemOther(ItemOther, Inform_Id, refreshAt);
        if (JobOther.Array)
          handleSubmitJobOther(JobOther, Inform_Id, refreshAt);
        if (files?.length > 0)
          handleUploadFile("ใบแจ้งงาน/Media", files, Inform_Id, refreshAt);
      },
        navigated: (navi) =>
          navi && refreshAt === "Inform" && commonNavigate(Inform_Id)
    });
  };

  const handleSubmitItemOther = (data, Inform_Id, refreshAt) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ItemOthersService.createItemOthers(data),
      navigated: (navi) =>
        navi && refreshAt === "ItemOther" && commonNavigate(Inform_Id)
    });
  };

  const handleSubmitJobOther = (data, Inform_Id, refreshAt) => {
    console.log(data)
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobOtherPricesService.createJobOtherPrices(data),
      navigated: (navi) =>
        navi && refreshAt === "JobOther" && commonNavigate(Inform_Id)
    });
  };

  const handleUploadFile = (destination, files, Inform_Id, refreshAt) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.createFileUploads(destination, files),
      callback: (response) => {
        const InformFile = {
          Array: response.files.map((item) => ({
            File_Path: `${destination}/${item}`,
            File_Type: ["jpg", "jpeg", "png"].includes(item.split(".").pop())
              ? "Image"
              : "Video",
            Inform_Other_Job_Id: Inform_Id
          }))
        };
        handleSubmitInformFiles(InformFile, Inform_Id, refreshAt);
      }
    });
  };

  const handleSubmitInformFiles = (data, Inform_Id, refreshAt) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest:
        InformOtherJobFilesService.createInformOtherJobFiles(data),
      navigated: (navi) =>
        navi && refreshAt === "InformFiles" && commonNavigate(Inform_Id)
    });
  };

  return <CreateJobForm onSubmitCallback={handleSubmit} />;
}
